import Transform from './Base';
import store from '@/store';
import { getDurationFormat } from '@/utils/utils';

const formatNumber = num => {
  if (!num) {
    return 0;
  }

  return Number(num.toFixed(2));
};

export default class EventsTransform extends Transform {
  /**
   * Method used to transform a fetched user.
   *
   * @param event The fetched user profile.
   *
   * @returns {Object} The transformed user profile.
   */
  static fetchCollection(items) {
    const fps = store?.getters['project/self']?.fps;
    return items.map(item => this.fetch(item, fps));
  }

  static fetch(event, fps) {
    const end_frame = event.end_frame || 0;
    const start_frame = event.start_frame || 0;

    return {
      id: event._id,
      job_id: event.job_id,
      distance: formatNumber(event.distance),
      duration: ((end_frame - start_frame) / fps).toFixed(1),
      end_frame,
      end_time: getDurationFormat(end_frame / fps),
      event: event.event || '',
      last_ball_x_rel: formatNumber(event.last_ball_x_rel),
      last_ball_y_rel: formatNumber(event.last_ball_y_rel),
      player: event.player || '',
      player_number: event.player_number || '',
      start_ball_x_rel: formatNumber(event.start_ball_x_rel),
      start_ball_y_rel: formatNumber(event.start_ball_y_rel),
      start_frame,
      start_time: getDurationFormat(start_frame / fps),
      team: event.team || '',
      track_id: event.track_id,
      z_max: formatNumber(event.z_max),
    };
  }

  static fetchEvent({ ball = {}, event = {}, frame_id }) {
    return {
      avr_speed: event.avr_speed ?? null,
      ball_x: ball.x_rel ?? null,
      ball_y: ball.y_rel ?? null,
      distance: event.distance ?? null,
      frame_id,
      last_ball_x: event.last_ball_x_rel ?? null,
      last_ball_y: event.last_ball_y_rel ?? null,
      start_ball_x: event.start_ball_x_rel ?? null,
      start_ball_y: event.start_ball_y_rel ?? null,
      z: ball.z ?? null,
      z_max: event.z_max ?? null,
    };
  }
}
